import { useSelector } from 'react-redux';
import {
  enableInventoryManualUpdateByFileBySupplier,
  enableInventoryManualUpdateByFileByEmail,
  enableInventoryManualUpdateWithPopupBySupplier,
  permittedUserRolesToEditInventoryQuantitiesViaPopup,
} from '../constants/featureFlag';
import { useFeatureFlag } from './useFeatureFlag';
import { getAuthorizedUsersAndSuppliersForFeatureFlag } from '../utils/user-based-feature-flag';

export function useInventoryManualUpdateByPopup() {
  const { user, supplierId } = useSelector((state) => state.role);
  const userEmail = user?.email;
  const featureFlagSupplierBasedValue = useFeatureFlag(
    enableInventoryManualUpdateWithPopupBySupplier,
    JSON.stringify([]),
  );

  return getAuthorizedUsersAndSuppliersForFeatureFlag({
    userEmail,
    supplierId,
    featureFlagSupplierBasedValue,
  });
}

export function useInventoryManualUpdateByFile() {
  const { user, supplierId } = useSelector((state) => state.role);
  const userEmail = user?.email;

  const featureFlagSupplierBasedValue = useFeatureFlag(enableInventoryManualUpdateByFileBySupplier, JSON.stringify([]));
  const featureFlagEmailBasedValue = useFeatureFlag(enableInventoryManualUpdateByFileByEmail, JSON.stringify([]));

  return getAuthorizedUsersAndSuppliersForFeatureFlag({
    userEmail,
    supplierId,
    featureFlagSupplierBasedValue,
    featureFlagEmailBasedValue,
  });
}

export function useInventoryManualUpdateByPopupAndFile() {
  const currentUserRole = useSelector((state) => state?.role?.user?.role);
  try {
    const permittedRoles =
      useFeatureFlag(permittedUserRolesToEditInventoryQuantitiesViaPopup, JSON.stringify([])) || [];
    return JSON.parse(permittedRoles).includes(currentUserRole);
  } catch (error) {
    console.error('Error fetching permitted roles', error);
    return false;
  }
}
